import type { FaireProductEntity } from "../../entity_types/product";

export const p_qwzy2f6d9b: FaireProductEntity = {
  token: "p_qwzy2f6d9b",
  type: "product",
  name: "Labradorite Butterfly Carving Natural Crystal Healing Energy",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/3760705b5eff923bb7881de973c2d8ce41739a3e60e1079c3de1def386ba55d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1ce46a949c29b95fdbf25dca44702d53ccc590c025d9fd34ab5b9ab1df9418ff.jpeg",
    "https://cdn.faire.com/fastly/031c6f5331cf31cff0709dcbe57fc3e94a5ae49ee90d42e8a63a1bfcf0f77bcc.jpeg",
    "https://cdn.faire.com/fastly/207e8918b83fbbbd62e4f5d601657eb03c35364e47dfea5f2683105eea82cbf3.jpeg",
  ],
  priceDollars: 5.2,
  description:
    "Add beautiful shimmer and color to your collection with these Natural Labradorite Butterfly carvings. Each butterfly is carefully carved from genuine labradorite and features the stone’s natural flash and iridescent color, making every piece unique.\n\nThese charming crystal butterflies are perfect for crystal shops, collectors, jewelry makers, gifts, or decorative displays. Labradorite is highly valued for its stunning flashes of blue, green, and gold and is often associated with transformation, protection, and spiritual growth.\n\nEach butterfly measures approximately 3.5 cm to 4 cm wide, making them ideal small display pieces or resale items.\n\n\t•\tEach piece has unique flash and natural patterns\n\t•\tNatural labradorite may contain natural cracks, inclusions, or imperfections\n\t•\tCondition: New\nMinimum order 12 pieces \n\nPerfect for crystal shops, resellers, collectors, or unique gift items.\n\nLocal pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.\n",
  tags: [],
  msrpDollars: 10.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:17.964Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
